// 定义一个接口，要求必须包含 event 属性
export type EventArg = {
  event: MouseEvent | KeyboardEvent;
};
export * from './contextmenu';
